import { gql } from '@efficiently/client-core-graphql-models';

export const GENERATE_MCP_API_KEY = gql(`
	mutation GenerateMcpApiKey {
		generateMcpApiKey {
			rawKey
			prefix
		}
	}
`);

export const GET_MCP_API_KEY_PREFIX = gql(`
	query McpApiKeyPrefix {
		mcpApiKeyPrefix
	}
`);
